  /*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */
import { apiFetch } from '../../../apiClient';
import { getSessionDatas } from '../../../utils';
import { showLoaing, saveStatus } from '../../App/state/action';
import { apiMap, settings } from '../../../config/constants';

export const savePQForm = (section) => dispatch => {
    dispatch(showLoaing(true));
    const { applicationId } = getSessionDatas();
    const updateBusinessParams = {
        hostname: settings.hostBusiness,
        paramsObj: {
            businessInfo: {
                appId: applicationId,
                ...section
            }
        },
        method: settings.put,
    };
    return apiFetch(apiMap.updateBusiness, updateBusinessParams)(dispatch)
                .then(res => {
                    return res;
                })
                .catch(error => {
                    dispatch(showLoaing(false));
                    throw error;
                });
 }
export const getQianHai = (comDocNum) => dispatch => {
    const { applicationId } = getSessionDatas();
    const data = {
        hostname: settings.hostnameQianhai,
        paramsObj: {
            appId: applicationId,
            verifyKey: comDocNum
        },
        method: settings.post,
    };
    return apiFetch(apiMap.getQianhai, data)(dispatch)
                .then(res => {
                    return res;
                })
                .catch(error => {
                    dispatch(showLoaing(false));
                    throw error;
                });
 }

export const updateStep = (data) => dispatch => {
    const { applicationId } = getSessionDatas();
    const updateStepParams = {
        hostname: settings.hostnameApplication,
        paramsObj: {
            "applicationId": applicationId,
            ...data
        },
        method: settings.put,
    };
    dispatch(saveStatus(data));
    apiFetch(apiMap.updateApplication, updateStepParams)(dispatch)
        .then(res => {
        })
        .catch(error => {
        })
}


// WEBPACK FOOTER //
// ./src/views/CompanyRegistration/state/action.js